<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <edit-profile-form :id="parseInt(this.$route.params.id)">

      </edit-profile-form>
    </div>
  </div>
</template>
<script>
  import EditProfileForm from './UserProfile/BGEditProfileForm.vue'

  export default {
    components: {
      EditProfileForm
    },
    created () {
      this.$log.debug('BGUserProfile.created ' + this.$route.params.id)
    },
    beforeCreate () {
      this.$log.debug('BGUserProfile.beforeCreate ' + this.$route.params.id)
    },
    mounted () {
      this.$log.debug('BGUserProfile.mounted ' + this.$route.params.id)
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGUserProfile.vue